module.exports = __webpack_public_path__ + "img/6.bfc68694.png";